import { render, staticRenderFns } from "./StoryEightView.vue?vue&type=template&id=c228c1ba&"
import script from "./StoryEightView.vue?vue&type=script&lang=js&"
export * from "./StoryEightView.vue?vue&type=script&lang=js&"
import style0 from "./StoryEightView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports